var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChatIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.29175 26.25V31.7421L9.50112 30.4165L16.4457 26.25H23.3334C24.942 26.25 26.2501 24.9419 26.2501 23.3333V11.6667C26.2501 10.0581 24.942 8.75 23.3334 8.75H5.83341C4.22487 8.75 2.91675 10.0581 2.91675 11.6667V23.3333C2.91675 24.9419 4.22487 26.25 5.83341 26.25H7.29175ZM5.83341 11.6667H23.3334V23.3333H15.6378L10.2084 26.5912V23.3333H5.83341V11.6667Z",
    fill: "#F8F8F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1667 2.91666H11.6667C10.0581 2.91666 8.75 4.22478 8.75 5.83332H26.25C27.8585 5.83332 29.1667 7.14145 29.1667 8.74999V20.4167C30.7752 20.4167 32.0833 19.1085 32.0833 17.5V5.83332C32.0833 4.22478 30.7752 2.91666 29.1667 2.91666Z",
    fill: "#F8F8F8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chatIcon.0cb464d7bbbdca363667ed156fdc5e81.svg";
export { ForwardRef as ReactComponent };